import React from 'react';
import { formatFieldName, formatValue, getBadgeColor } from '../../utils/formatters';

const TrackingSection = ({ trackingData }) => {
    if (!trackingData || typeof trackingData !== 'object') {
        return null;
    }

    // Convert tracking data object to entries array
    const trackingEntries = Object.entries(trackingData);

    if (trackingEntries.length === 0) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Tracking</h4>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '15px'
            }}>
                {trackingEntries.map(([field, value]) => {
                    // Handle arrays (like tracking_vendors)
                    let displayValue = value;
                    let isArray = false;
                    
                    if (Array.isArray(value)) {
                        isArray = true;
                        displayValue = value.length > 0 ? value : 'None';
                    }

                    // Determine if this is a boolean field
                    const isBoolean = typeof value === 'boolean';
                    const isCount = field.includes('count') && typeof value === 'number';

                    return (
                        <div
                            key={field}
                            style={{
                                backgroundColor: '#2d2d2d',
                                border: '1px solid #404040',
                                borderRadius: '6px',
                                padding: '15px'
                            }}
                        >
                            <div style={{
                                fontSize: '12px',
                                color: '#a0a0a0',
                                textTransform: 'uppercase',
                                marginBottom: '8px',
                                fontWeight: '600',
                                letterSpacing: '0.5px'
                            }}>
                                {formatFieldName(field)}
                            </div>
                            <div style={{ fontSize: '18px', fontWeight: 'bold' }}>
                                {isArray && Array.isArray(value) && value.length > 0 ? (
                                    <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                                        {value.map((item, index) => (
                                            <span
                                                key={index}
                                                style={{
                                                    display: 'inline-block',
                                                    backgroundColor: getBadgeColor(field, item),
                                                    color: '#fff',
                                                    padding: '4px 12px',
                                                    borderRadius: '12px',
                                                    fontSize: '14px',
                                                    marginBottom: '4px'
                                                }}
                                            >
                                                {formatValue(item)}
                                            </span>
                                        ))}
                                    </div>
                                ) : isArray ? (
                                    <span style={{
                                        display: 'inline-block',
                                        backgroundColor: '#6b7280',
                                        color: '#fff',
                                        padding: '4px 12px',
                                        borderRadius: '12px',
                                        fontSize: '14px'
                                    }}>
                                        {formatValue(displayValue)}
                                    </span>
                                ) : (
                                    <span style={{
                                        display: 'inline-block',
                                        backgroundColor: getBadgeColor(field, value),
                                        color: '#fff',
                                        padding: '4px 12px',
                                        borderRadius: '12px',
                                        fontSize: '14px'
                                    }}>
                                        {formatValue(value)}
                                    </span>
                                )}
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default TrackingSection;

